import { Account } from '@libs/src/models/account.model';

export interface MembersState {
  accounts: Account[][];
  currentPage: number;
  isAdminMode: boolean;
  isFetching: boolean;
  isInitialized: boolean;
  searchParams?: MembersSearchParams;
  totalCount: number;
  viewMode: VIEW_MODES;
}

export interface MembersSearchParams {
  geo_location?: string;
  group?: string;
  'group.industries'?: string[];
  'group.offerings'?: string[];
  'group.roles'?: string[];
  isAdmin?: boolean;
  keyword?: string;
  limit?: number;
  offset?: number;
  order?: string;
  skip?: number;
  sort?: string;
}

export enum VIEW_MODES {
  cards = 'cards',
  table = 'table',
}

export const DEFAULT_GET_PARAMS: MembersSearchParams = {
  limit: 10,
};
